<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="siteIds">
          <el-cascader
              v-model="detailFormData.siteIds"
              disabled
              :options="options"
              :props="props"
              clearable></el-cascader>
        </template>
        <template slot="radio">
          <el-radio-group v-model="detailFormData.isAreaManager" disabled>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserMasterViewPage',
  isAutoComponent: true,
  data() {
    return {
      props: { multiple: true, children: 'children', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover' },
      options: [],
      detailForm: {
        title: '站长详情',
        className: 'wt-section-long-content',
        elements: [
          { name: '账号',
            key: 'userName',
            type: 'text',
            required: false,
            disabled: true },
          { name: '站点',
            key: 'siteIds',
            type: 'custom',
            required: false,
            disabled: true },
          { name: '姓名',
            key: 'name',
            type: 'text',
            required: false,
            disabled: true },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            required: false,
            disabled: true },
          { name: '是否有区域负责人权限',
            key: 'radio',
            type: 'custom',
            required: false,
            disabled: false }]
      },
      detailFormButtons: {
        title: '站长详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      checkList: []
    }
  },
  created() {
    this.siteTreeList()
  },
  mounted() {
    const siteIds = []
    for (const item of this.detailFormData.siteList) {
      siteIds.push(item.id)
    }
    this.detailFormData.siteIds = siteIds
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    // 社区
    siteTreeList() {
      this.$api.siteManage.site.siteTreeListByOrg({
        isDeliveryEnabled: 0,
        type: 1
        // userId: this.detailFormData.id
      }).then(res => {
        this.options = res.data
      })
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userMaster.userMasterDetailData
    })
  }
}
</script>

<style scoped>
.action-check-group {
  padding-left: 180px;
}
.action-check-group .el-checkbox {
  margin-bottom: 8px;
}
</style>
